import { twMerge } from "tailwind-merge"
import { clsx } from "clsx"

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

export const getCommonPinningStyles = (column, row) => {
    const isSelected = row?.getIsSelected()
    const isPinned = column.getIsPinned();
    const isLastLeftPinnedColumn =
        isPinned === 'left' && column.getIsLastColumn('left');
    const isFirstRightPinnedColumn =
        isPinned === 'right' && column.getIsFirstColumn('right');

    return {
        background: isSelected ? 'linear-gradient(to bottom, #456565, #50A1A1)' : '#fff',
        boxShadow: isLastLeftPinnedColumn
            ? '-4px 0 2px -4px gray inset'
            : isFirstRightPinnedColumn
                ? '4px 0 4px -4px gray inset'
                : undefined,
        left: isPinned === 'left' ? `${column.getStart('left')}px` : undefined,
        right: isPinned === 'right' ? `${column.getAfter('right')}px` : undefined,
        opacity: isPinned ? 0.95 : 1,
        position: isPinned ? 'sticky' : 'relative',
        zIndex: isPinned ? 1 : 0,
    };
};